import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { createElement } from 'react';
import { CreateSVG } from "../lib/index.js";
function SvgIconTrash(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/createElement(CreateSVG, _objectSpread(_objectSpread({}, props), {}, {
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 52 52",
        xmlSpace: "preserve",
        enableBackground: "new 0 0 52 52",
        "aria-labelledby": titleId
      }, props), title ? /*#__PURE__*/React.createElement("title", {
        id: titleId
      }, title) : null, /*#__PURE__*/React.createElement("style", {
        type: "text/css"
      }, '.Icon-trash_svg__st0{display:none}.Icon-trash_svg__st1{display:inline;fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-trash_svg__st2{display:inline}.Icon-trash_svg__st3{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-trash_svg__st4{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-trash_svg__st5{display:inline;fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-trash_svg__st6{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10}.Icon-trash_svg__st7{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10}.Icon-trash_svg__st8{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10}.Icon-trash_svg__st9{stroke:#000000;stroke-width:2;stroke-miterlimit:10}.Icon-trash_svg__st10{fill:none;stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10}.Icon-trash_svg__st11{fill:none;stroke:#000000;stroke-width:4;stroke-linejoin:round;stroke-miterlimit:10}.Icon-trash_svg__st12{stroke:#000000;stroke-width:0.4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-trash_svg__st13{stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-trash_svg__st14{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}.Icon-trash_svg__st15{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0.1032,4.127}.Icon-trash_svg__st16{display:inline;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-trash_svg__st17{fill:none}'), /*#__PURE__*/React.createElement("g", {
        id: "Icon-trash_svg__stroke",
        className: "Icon-trash_svg__st0"
      }, /*#__PURE__*/React.createElement("g", {
        className: "Icon-trash_svg__st2"
      }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
        className: "Icon-trash_svg__st3",
        d: "M38,16l-1,29c0,0.55-0.45,1-1,1H16c-0.55,0-1-0.45-1-1l-1-29"
      }))), /*#__PURE__*/React.createElement("rect", {
        x: 11,
        y: 12,
        className: "Icon-trash_svg__st3",
        width: 30,
        height: 4
      }), /*#__PURE__*/React.createElement("line", {
        className: "Icon-trash_svg__st3",
        x1: 20,
        y1: 22,
        x2: 20,
        y2: 40
      }), /*#__PURE__*/React.createElement("line", {
        className: "Icon-trash_svg__st3",
        x1: 26,
        y1: 22,
        x2: 26,
        y2: 40
      }), /*#__PURE__*/React.createElement("line", {
        className: "Icon-trash_svg__st3",
        x1: 32,
        y1: 22,
        x2: 32,
        y2: 40
      }), /*#__PURE__*/React.createElement("path", {
        className: "Icon-trash_svg__st7",
        d: "M21,12V8c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2v4"
      }))), /*#__PURE__*/React.createElement("g", {
        id: "Icon-trash_svg__filled"
      }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
        d: "M32,9h-2V8c0-0.5518-0.4482-1-1-1h-6c-0.5518,0-1,0.4482-1,1v1h-2V8c0-1.6543,1.3457-3,3-3h6c1.6543,0,3,1.3457,3,3V9z"
      })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
        d: "M41,11H11c-0.5527,0-1,0.4473-1,1v4c0,0.5527,0.4473,1,1,1h30c0.5527,0,1-0.4473,1-1v-4C42,11.4473,41.5527,11,41,11z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M13.1033,19L14,45c0,1.1025,0.8975,2,2,2h20c1.1025,0,2-0.8975,1.999-1.9658L38.8967,19H13.1033z M21,40 c0,0.5527-0.4473,1-1,1s-1-0.4473-1-1V22c0-0.5527,0.4473-1,1-1s1,0.4473,1,1V40z M27,40c0,0.5527-0.4473,1-1,1s-1-0.4473-1-1V22 c0-0.5527,0.4473-1,1-1s1,0.4473,1,1V40z M33,40c0,0.5527-0.4473,1-1,1s-1-0.4473-1-1V22c0-0.5527,0.4473-1,1-1s1,0.4473,1,1V40z "
      })))));
    }
  }));
}
export default SvgIconTrash;